import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./auth";
import { QueryClient } from "@tanstack/react-query";
import MantineProvider from "./MantineProvider";
import { NotificationControlProvider } from "./notificationContext";
import LanguageProvider from "./LanguageProvider";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

interface IProps {
  children: React.ReactNode;
}

export default function Providers({ children }: IProps) {
  return (
    <LanguageProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <MantineProvider>
              <NotificationControlProvider>
                {children}
              </NotificationControlProvider>
            </MantineProvider>
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </LanguageProvider>
  );
}
